import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageOrdersTable} from "../../UI/Main/ManageOrdersTable";

const ManageOrders = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManageOrdersTable />} />
        </div>
    );
};

export default ManageOrders;
